import { Card } from '@mui/material';
import { styled } from '@mui/system';
import { theme } from '../theme';

export const InfoCard = styled(Card)({
  marginBottom: theme.spacing(5),
});
